<template>
  <header class="header-global">
    <base-nav class="navbar-main" transparent type="" effect="light" expand>
      <router-link slot="brand" class="navbar-brand mr-lg-5" to="/">
        <img src="img/brand/white.png" alt="logo" />
      </router-link>

      <div class="row" slot="content-header" slot-scope="{ closeMenu }">
        <div class="col-6 collapse-brand">
          <a href="/">
            <img src="img/brand/black.png" />
          </a>
        </div>
        <div class="col-6 collapse-close">
          <close-button @click="closeMenu"></close-button>
        </div>
      </div>

      <ul class="navbar-nav navbar-nav-hover align-items-lg-center">
        <a slot="title" href="/what-we-teach" class="nav-link" role="button">
          <span class="nav-link-inner--text">What We Teach</span>
        </a>
        <a slot="title" href="/our-ministries" class="nav-link" role="button">
          <span class="nav-link-inner--text">Our Ministries</span>
        </a>
        <a slot="title" href="/our-leaders" class="nav-link" role="button">
          <span class="nav-ink-inner--text">&nbsp;Our Leaders</span>
        </a>
        <a slot="title" href="/church-planting" class="nav-link" role="button">
          <span class="nav-link-inner--text">Church Planting</span>
        </a>
        <a slot="title" href="/affiliates" class="nav-link" role="button">
          <span class="nav-link-inner--text">Affiliates</span>
        </a>
        <a slot="title" href="/giving" class="nav-link" role="button">
          <span class="nav-ink-inner--text">&nbsp;Giving</span>
        </a>
        <a
          slot="title"
          href=" "
          class="nav-link d-block d-lg-none"
          role="button"
        >
          <span class="nav-ink-inner--text">&nbsp;Contact Us</span>
        </a>
      </ul>
      <!-- Contact Us -->
      <ul class="navbar-nav align-items-lg-center ml-lg-auto">
        <li class="nav-item d-none d-lg-block ml-lg-4">
          <a href="/#contact-us">
            <base-button type="primary"> Contact Us </base-button>
          </a>
        </li>
      </ul>
    </base-nav>
  </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";

export default {
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown,
  },
};
</script>
<style></style>
